import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

$(document).ready(function() {
  if (!Abacus.PreventDefault.ReCaptcha) {
    Abacus.ReCaptcha = new ReCaptcha();
  }
});

class ReCaptcha extends Class {
  constructor(options) {
    super();
    this.setUpEvents();
    this.requested = false;
  }

  setUpEvents() {
    var self = this;

    window.reCaptchaLoaded = function() {
      self.loaded = true;
      $(document).trigger("abacus:recapture:loaded");
    };
  }

  isLoaded() {
    return !!window.grecaptcha;
  }

  loadReCapture() {
    if (this.requested) return;
    this.requested = true;
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src =
      "//www.google.com/recaptcha/api.js?onload=reCaptchaLoaded&render=explicit";
    $("head").append(script);
  }
}

let reCaptchaElementOptions = {
  captchaTest: ".g-recaptcha",
  validationElement: ".captchatest"
};

class ReCaptchaElement extends Class {
  constructor(element, options) {
    super();
    this.setOptions(reCaptchaElementOptions, options);
    this.element = $(element);

    if (this.element.attr("data-initiated-recaptcha")) {
      return;
    }

    this.$captchaTest = this.element.find(this.options.captchaTest);
    this.$validationElement = this.element.find(this.options.validationElement);
    this.sitekey = this.$captchaTest.data("sitekey");
    this.loadReCapture();
    this.element.attr("data-initiated-recaptcha", true);
  }

  loadReCapture(params) {
    if (!Abacus.ReCaptcha.isLoaded()) {
      Abacus.ReCaptcha.loadReCapture();
      this.setUpEvents();
    } else {
      this.render();
    }
  }

  setUpEvents() {
    var self = this;

    $(document).on("abacus:recapture:loaded", function() {
      self.render();
    });
  }

  render() {
    var self = this;
    for (var i = 0, iL = this.$captchaTest.length; i < iL; i++) {
      grecaptcha.render(this.$captchaTest[i], {
        sitekey: self.sitekey,
        callback: function(response) {
          self.$validationElement.attr("value", response);
        },
        "expired-callback": function() {
          self.$validationElement.removeAttr("value");
          grecaptcha.reset(captchaId);
        }
      });
    }
  }
}

export { ReCaptcha, ReCaptchaElement };



// WEBPACK FOOTER //
// ./Javascript/core/classes/recaptcha.class.js